export const SITE = {
  name: "Düzbağ Life",
  fullName: "Düzbağ Life Bungalov & Restaurant",
  subtitle: "Bungalov & Restaurant",
  whatsappNumber: "905335247495",
  whatsappBase: "https://wa.me/905335247495",
  phoneDisplay: "+90 533 524 74 95",
  phoneTel: "+905335247495",
  instagramHandle: "@duzbaglife_bungalov",
  instagramUrl: "https://www.instagram.com/duzbaglife_bungalov/",
  addressLine1: "Karadağ Mahallesi, Helete Karadağ, Karaçay Sk. No:28",
  addressLine2: "Çağlayancerit / Kahramanmaraş",
  mapsEmbed:
    "https://maps.google.com/maps?q=Karada%C4%9F%20Mahallesi%20Helete%20Karada%C4%9F%20Kara%C3%A7ay%20Sk.%20No%3A28%20%C3%87a%C4%9Flayancerit%20Kahramanmara%C5%9F&t=&z=12&ie=UTF8&iwloc=&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=D%C3%BCzba%C4%9F%20Life%20Bungalov%20%26%20Restaurant%2C%20Karada%C4%9F%20Mahallesi%2C%20%C3%87a%C4%9Flayancerit%2C%20Kahramanmara%C5%9F",
};

/**
 * Real property photographs supplied by the business.
 * night / exterior / bedroom / living / livingStove / stairs / mezzanine / bath / pool
 */
export const IMAGES = {
  night:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/baffc3f2-3fdf-48f6-a9da-58bde2c7fb2c_compressed_r1.webp",
  bath: "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/30cca4d9-585b-47c2-85d7-a35153aed73d_compressed_r2.webp",
  bedroom:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/d6cf766d-4365-432c-a764-5d082b7da43f_compressed_r5.webp",
  living:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/2748a044-4593-4bdd-92c2-6e874e9ec1b9_compressed_r6.webp",
  livingStove:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/e651b015-7a92-432c-be6c-5b3e32300ec3_compressed_r7.webp",
  stairs:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/ce852048-ffd5-447e-9168-303a8af56977_compressed_r8.webp",
  mezzanine:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/410bca1c-97af-4258-87e1-bb907647f502_compressed_r9.webp",
  exterior:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/65ae5279-43ff-4dde-9e39-ce29411855de_compressed_r29.webp",
  restaurant:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/6b2bc652-1c74-4ba4-bc9d-544fd0e2d1bd_compressed_r10.webp",
  sauna:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/6374d3bb-4d86-4a97-93fd-2ac116ea9437_compressed_r27.webp",
  saunaAlt:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/ac5a372f-15a6-45b1-bcea-eb6bc2aba8ac_compressed_r11.webp",
  hammam:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/3ddaf427-41fe-4d13-8b5e-54fcb5cb45c5_compressed_r12.webp",
  steam:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/b013c42b-db2f-42a8-8ba2-bfe504002a25_compressed_r14.webp",
  massage:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/c8ce66db-a5ab-4790-9c19-0eea87aa1d8c_compressed_r15.webp",
  pool: "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/dac021cf-8e8c-4dc7-a708-c001abfb7637_compressed_r16.webp",
  garden:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/ac79018b-00f3-48d2-a929-c0aaca56540b_compressed_r13.webp",
  aerial:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/1fbf4b72-12c5-4b31-8963-7f8eaf094ff9_compressed_r17.webp",
  aerialRiver:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/ade9a43d-e865-4b8d-9519-466256255a45_compressed_r18.webp",
  video:
    "https://storage.helloreaddy.io/project_files/dfbefa19-f682-40ac-90d2-111c0304a14b/51428b70-a9a8-4eb1-ba21-090ec935c1be_v1.mp4",
};

export const NAV_LINKS = [
  { label: "Ana Sayfa", href: "#top" },
  { label: "Bungalovlar", href: "#bungalovlar" },
  { label: "Deneyim", href: "#deneyim" },
  { label: "Spa & Wellness", href: "#spa" },
  { label: "Restaurant", href: "#restaurant" },
  { label: "Galeri", href: "#galeri" },
  { label: "Konum", href: "#konum" },
];

export function whatsappLink(message?: string): string {
  if (!message) return SITE.whatsappBase;
  return `${SITE.whatsappBase}?text=${encodeURIComponent(message)}`;
}

export const DEFAULT_WA_MESSAGE =
  "Merhaba Düzbağ Life, tesis ve rezervasyon hakkında bilgi almak istiyorum.";